module.exports = __webpack_public_path__ + "img/consensys.720c795d.png";